var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "24",
        height: "16",
        viewBox: "0 0 24 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M22 0H2C0.89543 0 0 0.89543 0 2V14C0 15.1046 0.89543 16 2 16H22C23.1046 16 24 15.1046 24 14V2C24 0.89543 23.1046 0 22 0Z",
          fill: "#016FD0"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M13.7641 13.3939V7.69247L23.9116 7.70158V9.27647L22.7387 10.5299L23.9116 11.7948V13.4031H22.039L21.0438 12.3049L20.0557 13.4072L13.7641 13.3939Z",
          fill: "#FFFFFE"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M14.4418 12.7688V8.31992H18.2141V9.3448H15.6632V10.0405H18.1533V11.0483H15.6632V11.7316H18.2141V12.7688H14.4418Z",
          fill: "#016FD0"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M18.1953 12.7688L20.2826 10.5418L18.1952 8.32001H19.8108L21.0863 9.73004L22.3654 8.32001H23.9116V8.35501L21.8687 10.5418L23.9116 12.7057V12.7688H22.3499L21.0518 11.3446L19.767 12.7688H18.1953Z",
          fill: "#016FD0"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M14.2373 2.63196H16.6834L17.5425 4.58281V2.63196H20.5624L21.0831 4.09353L21.6057 2.63196H23.9116V8.33335H11.7251L14.2373 2.63196Z",
          fill: "#FFFFFE"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M14.7005 3.25134L12.7265 7.69651H14.0804L14.4528 6.80635H16.4707L16.8429 7.69651H18.2305L16.2647 3.25134H14.7005ZM14.8701 5.80878L15.4621 4.39371L16.0537 5.80878H14.8701Z",
          fill: "#016FD0"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M18.212 7.69572V3.25064L20.1151 3.25718L21.0944 5.98991L22.08 3.25064H23.9116V7.69572L22.733 7.70615V4.65281L21.6204 7.69572H20.5446L19.409 4.64238V7.69572H18.212Z",
          fill: "#016FD0"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }